module.exports = __webpack_public_path__ + "img/BB.fe507309.png";